<template>
    <div class="col-lg-5 col-md-7">
        <div class="">
            <div class=" px-lg-5 pt-lg-5 pb-lg-2">
                <div class="login-header text-center mb-4">{{ $t('login') }}/{{ $t('register') }}</div>
                <base-alert type="danger" v-if="error">{{error}}</base-alert>

                <base-input class="input-group-alternative mb-3"
                            ref="login"
                            :placeholder="$t('enter_email_or_phone')"
                            :error="fieldError('login')"
                            addon-left-icon="ni ni-email-83"
                            addon-right-icon="ni ni-mobile-button"
                            @keyup.enter.prevent="checkLogin"
                            v-model="login">
                </base-input>


                <div class="text-center">
                    <base-button
                            data-model="user"
                            data-action="check-login"
                            data-label="Продожить"
                            class="my-4 px-5 py-3 login-btn" @click="checkLogin"
                            :disabled="!submitEnabled">
                        {{ $t('continue') }}
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import userApi from "../../data/UserApi";


    export default {
        name: 'CheckLogin',
        props: {
            defaultLogin: String,
        },
        data() {
            return {
                login: '',

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },

        computed: {
            submitEnabled() {
                return this.login
            },
        },

        mounted() {
            if (this.defaultLogin) {
                this.login = this.defaultLogin
                this.checkLogin()
            } else {
                this.$refs.login.$el.querySelector('input').focus()
            }
        },

        watch: {
            defaultLogin: function () {
                if (this.defaultLogin) {
                    this.login = this.defaultLogin
                    this.checkLogin()
                }
            }
        },

        methods: {
            checkLogin() {
                if (this.submitEnabled) {
                    userApi.checkLogin(this.login)
                        .then(response => {
                            this.loading = false
                            this.$emit('checked', response);
                        })
                        .catch(error => {
                            let data = error.response.data
                            if (error.response.status === 422) {
                                this.fieldsErrors = data
                            } else {
                                this.error = this.pretty(data)
                            }
                            this.loading = false
                        })
                }
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>
